import { AgeGenderDistributionValue } from "../models/AgeGenderDistribution.model";

export function SortAgeGenderDistributionValuesById(ageGenderDistributionValues: AgeGenderDistributionValue[]): AgeGenderDistributionValue[] {
    return ageGenderDistributionValues.sort((s1, s2) => {
        if (s1.ageGenderId > s2.ageGenderId) {
            return 1;
        }
        if (s1.ageGenderId < s2.ageGenderId) {

            return -1;
        }
        return 0;
    });
}